export const serializeFormData = (e) => {
  const formData = new FormData(e.target);

  return Array.from(formData.entries()).reduce((acc, [key, value]) => {
    acc[key] = value;
    return acc;
  }, {});
};
